import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header header-elements-inline" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Projektunterlagen"),
  /*#__PURE__*/_createElementVNode("div", { class: "header-elements" })
], -1)
const _hoisted_5 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mr-3" }
const _hoisted_8 = {
  href: "#",
  class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon"
}
const _hoisted_9 = { class: "media-body" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", { class: "list-icons-item" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: ""
          }, [
            _createElementVNode("a", {
              class: "media cursor-pointer",
              onClick: ($event: any) => (_ctx.showFile(file))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", _hoisted_8, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.fileTypes[file.type]?.icon)
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(file.name), 1),
              _hoisted_10
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ])
  ]))
}